const isSizeChanged = (observable, width, height) => {
  return observable.size.width !== width || observable.size.height !== height;
};

export class ResizeObserver {
  constructor(callback) {
    this._callback = callback;
    this._observedElements = [];
    this._boundCheck = this._check.bind(this);
    this._boundCheck();
  }

  observe(element) {
    const { width, height } = element.getBoundingClientRect();
    this._observedElements.push({
      element: element,
      size: {
        height: height,
        width: width
      }
    });
  }

  unobserve(element) {
    this._observedElements = this._observedElements.filter(observed => observed.element !== element);
  }

  _check() {
    this._observedElements.forEach(observed => {
      const { width, height } = observed.element.getBoundingClientRect();

      if (isSizeChanged(observed, width, height)) {
        observed.size.width = width;
        observed.size.height = height;

        this._callback();
      }
    });

    window.requestAnimationFrame(this._boundCheck);
  }
};
